import React from 'react';
import { NavLink } from 'react-router-dom';

const NavItem = ({ url, icon, title, alertsCount, alertsTouched }) => {
    return (
        <li className="nav__list-item">
            <NavLink className="nav__link" activeClassName="is-active" to={url}>
                {alertsCount > 0 &&
                title === 'Alerts / Task Queue' &&
                !alertsTouched ? (
                    <div className="alertscount">{alertsCount}</div>
                ) : null}
                <svg className={`icon icon-${icon} main-icon`}>
                    <use xlinkHref={`#icon-${icon}`} />
                </svg>
                <span className="nav__link-title">{title}</span>
            </NavLink>
        </li>
    );
};
export default NavItem;



// WEBPACK FOOTER //
// ./src/components/navigation/nav-item.js